/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { isNone, isEmpty } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import AnalyticsService from 'cio/services/analytics';
import isValidEmail from 'cio/utils/validators/email';

interface IntegrationsGatherEmailArgs {
  integrationName: string;
  onSubmit: (value: string) => unknown;
  onClose: () => unknown;
}

export default class IntegrationsGatherEmail extends Component<IntegrationsGatherEmailArgs> {
  @service analytics!: AnalyticsService;

  @tracked userEmail = '';

  get submitDisabled() {
    if (isNone(this.userEmail) || isEmpty(this.userEmail.trim()) || !isValidEmail(this.userEmail.trim())) {
      return true;
    }

    return false;
  }

  @action
  onFormSubmit(evt: Event) {
    evt.preventDefault();

    if (this.submitDisabled) {
      return;
    }

    this.args.onSubmit(this.userEmail);
  }
}
